<script>
import { Bar, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Bar,
  name: 'LeadOverviewGraph',
  mixins: [reactiveProp],

  data: () => ({
    options: {
      maintainAspectRatio: false,
      responsive: true,
      layout: {
        padding: {
          top: 0,
        },
      },
      legend: {
        display: false,
      },
      scales: {
        xAxes: [{
          type: 'time',
          offset: true,
          distribution: 'series',
          time: {
            unit: 'month',
            source: 'data',
            displayFormats: {
              month: 'MMM YY',
            },
            tooltipFormat: 'DD-MMM',
          },
          gridLines: {
            drawOnChartArea: false,
            tickMarkLength: 0,
            zeroLineWidth: 0,
          },
          ticks: {
            maxRotation: 0,
            padding: 10,
          },
        }],
        yAxes: [{
          type: 'linear',
          gridLines: {
            drawTicks: false,
          },
          ticks: {
            min: 0,
            padding: 10,
            precision: 0,
          },
        }],
      },
      tooltips: {
        callbacks: {
          label: (tooltip, data) => `${tooltip.yLabel} Leads`,
          title: () => null,
        },
        custom: (tooltip) => {
          if (!tooltip) return
          tooltip.displayColors = false
          if (tooltip.xAlign === 'left') tooltip.x += 10
          if (tooltip.xAlign === 'right') tooltip.x -= 10
          if (tooltip.yAlign === 'top') tooltip.y += 10
        },
        xPadding: 10,
        yPadding: 10,
      },
    },
  }),

  mounted () {
    this.renderChart(this.chartData, this.options)
  },
}
</script>

<style lang="scss" scoped>

</style>
